import React from "react";
import styled from "styled-components";

const Row = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #eeeeee;
  padding: 8px 16px;
  cursor: pointer;

  &:last-child {
    border-bottom: 0;
  }
`;

const Column = styled.div`
  font-family: ${(props) => props.theme.typo.fontFamily};
  font-size: 14px;
  color: ${(props) => props.theme.palette.primary};
  width: 100%;
  flex-basis: 100%;
`;

const LightText = styled.span`
  color: #949494;
  font-size: 12px;
`;

const Extraction = ({ label, value, confidence, onMouseOver, onMouseOut }) => (
  <Row onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
    <Column>
      <LightText>{label}</LightText>
    </Column>
    <Column>{value}</Column>
    {confidence !== "0%" && (
      <Column>
        <LightText>Confidence: {confidence}</LightText>
      </Column>
    )}
  </Row>
);

export default Extraction;
